var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "jump-to-nav",
    {
      staticClass: "laptop:position-sticky-top laptop:padding-y-2xl",
      attrs: { title: "On This Page" },
    },
    [
      _c(
        "list",
        [
          _c("list-item", { attrs: { hash: "#background" } }, [
            _vm._v("Background"),
          ]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#license" } }, [_vm._v("License")]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#what-the-customer-may-do" } }, [
            _vm._v("What the Customer May Do"),
          ]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#what-creators-may-do" } }, [
            _vm._v("What Creators May Do"),
          ]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#what-creators-may-not-do" } }, [
            _vm._v("What Creators May Not Do"),
          ]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#updates" } }, [_vm._v("Updates")]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#downloads" } }, [
            _vm._v("Downloads"),
          ]),
          _vm._v(" "),
          _c(
            "list-item",
            { attrs: { hash: "#web-store-credentials-and-keys" } },
            [_vm._v("Web Store Credentials and Keys")]
          ),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#payment" } }, [_vm._v("Payment")]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#term" } }, [_vm._v("Term")]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#enforcement" } }, [
            _vm._v("Enforcement"),
          ]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#guarantee" } }, [
            _vm._v("Guarantee"),
          ]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#disclaimer" } }, [
            _vm._v("Disclaimer"),
          ]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#limited-damages" } }, [
            _vm._v("Limited Damages"),
          ]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#general-contract-terms" } }, [
            _vm._v("General Contract Terms"),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }